var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 18.3346C5.39685 18.3346 1.66602 14.6038 1.66602 10.0013C1.66602 5.3988 5.39685 1.66797 9.99935 1.66797C14.6018 1.66797 18.3327 5.3988 18.3327 10.0013C18.3327 14.6038 14.6018 18.3346 9.99935 18.3346ZM10.8327 6.66797C10.8327 7.12821 10.4596 7.5013 9.99935 7.5013C9.53911 7.5013 9.16602 7.12821 9.16602 6.66797C9.16602 6.20773 9.53911 5.83464 9.99935 5.83464C10.4596 5.83464 10.8327 6.20773 10.8327 6.66797ZM9.99935 8.33464C10.4596 8.33464 10.8327 8.70773 10.8327 9.16797V13.3346C10.8327 13.7949 10.4596 14.168 9.99935 14.168C9.53911 14.168 9.16602 13.7949 9.16602 13.3346V9.16797C9.16602 8.70773 9.53911 8.33464 9.99935 8.33464Z",
    fill: "#052B5F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateInfoIcon);
export default __webpack_public_path__ + "static/media/generateInfoIcon.fd395b003513b93a44e8f7fd2b24d829.svg";
export { ForwardRef as ReactComponent };